export type Callback = () => void;

export class Timer {
  public destroyed: boolean = false;
  public time: number;
  private repeat: number;
  private callback: Callback | null;
  private elapsedTime: number = 0;

  constructor(time: number, repeat: number, callback: Callback) {
    this.time = time;
    this.repeat = repeat;
    this.callback = callback;
  }

  public update(deltaMs: number): void {
    if (this.destroyed) return;
    this.elapsedTime += deltaMs;

    if (this.elapsedTime >= this.time) {
      if (this.callback) this.callback();
      if (this.repeat > 0) this.repeat -= 1;
      if (this.repeat === 0) {
        this.destroy();
      } else {
        this.elapsedTime -= this.time;
      }
    }
  }

  public destroy(): void {
    this.destroyed = true;
    this.callback = null;
  }
}
